import { render, staticRenderFns } from "./VueTableWin.vue?vue&type=template&id=ec2c3ce0&scoped=true&"
import script from "./VueTableWin.vue?vue&type=script&lang=js&"
export * from "./VueTableWin.vue?vue&type=script&lang=js&"
import style0 from "./VueTableWin.vue?vue&type=style&index=0&id=ec2c3ce0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2c3ce0",
  null
  
)

export default component.exports